import React, {Component} from 'react';
import closeDoctorFilterIcon from "../../img/closeDoctorFilter.png";
import ApiConnector from '../api/ApiConnector'
import GlobalStore from "../../store/GlobalStore";
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import './FilterCalendar.css';
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

let currentThis;

const WEEKDAYS_SHORT = {
    fi: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La']
};
const MONTHS = {
    fi: ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"]
};

const WEEKDAYS_LONG = {
    fi: ['Sunnuntai', 'Maanantai', 'Tiistai', 'Keskiviikko', 'Torstai', 'Perjantai', 'Lauantai']
};

const FIRST_DAY_OF_WEEK = {
    fi: 1
};
// Translate aria-labels
const LABELS = {
    fi: {nextMonth: 'Ensikuussa', previousMonth: 'Edelliseen kuukauteen'}
};


class FilterCalendar extends Component {
    constructor(props) {
        super(props);
        this.getDayDelta = this.getDayDelta.bind(this);
        this.disableFilterDoctor = this.disableFilterDoctor.bind(this);
        this.state = {
            freeDayList: [],
            loader: true
        };
    };

    componentDidMount() {
        currentThis = this;
        //получаємо поточну сьогоднішню дату та кінцеву годину поточнох дати, формуємо JSON та відправляємо на API
        let lastHourCurrentDate = new Date();
        let currentDate = new Date();
        let currentDay = currentDate.getDate();
        let currentMonth = currentDate.getMonth() + 1;
        let currentYear = currentDate.getFullYear();

        if (currentDay < 10) {
            currentDay = '0' + currentDay;
        }
        if (currentMonth < 10) {
            currentMonth = '0' + currentMonth;
        }

        let currentDayMyFormat = "" + currentYear + "-" + currentMonth + "-" + currentDay + "+00%3A00";

        lastHourCurrentDate.setFullYear(currentYear + 1);
        lastHourCurrentDate = lastHourCurrentDate.toJSON();

        let filterDoctorId;
        let currentSubCategoryId = GlobalStore.getInstance().data['categories'];
        let currentStateFilterDoctorId = GlobalStore.getInstance().data['filterDoctorId'];
        let officeId = GlobalStore.getInstance().data['office'];
        if (currentStateFilterDoctorId != null) {
            filterDoctorId = currentStateFilterDoctorId;
        }

        let getApiTimeList = ApiConnector.getTimeList(currentSubCategoryId, currentDayMyFormat, lastHourCurrentDate, filterDoctorId, 'Days', officeId);

        getApiTimeList
            .then(data => {
                let resultApiTimeList = data.map((item) => {
                    return new Date(item.Day);
                });
                this.setState({freeDayList: resultApiTimeList, loader: false});
            }).catch((reason) => {
                console.log(reason)
                this.setState({loader: false});
                NotificationManager.warning('Pyyntö evätty internet-yhteysongelman vuoksi. Klikkaa tästä lähettääksesi pyyntö uudelleen', 'Yhteysongelma', 10000, () => {
                    this.componentDidMount();
                });
        });
    };

    getDayDelta(incomingDate, todayDate) {
        let oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        return Math.round(Math.abs((incomingDate.getTime() - todayDate.getTime()) / (oneDay)));
    }

    handleDayClick(day, {selected}) {
        if (selected) {
            day.setHours(0, 0, 0);
            let currentDate = new Date();
            currentDate.setHours(0, 0, 0);
            let resultGetDayDelta = currentThis.getDayDelta(day, currentDate);
            currentThis.props.openDateFromCalendar(resultGetDayDelta);
        }
    };

    disableFilterDoctor() {
        this.setState({loader: true});
        //TODO: потестити таку діч чи воно не буде творити проблеми з асинхроністю, тобто шоб воно завжи встигало записати перж ніж оновити
        this.props.disableFilterDoctor();
        this.componentDidMount();
    }

    render() {
        return (
            <div className="filterCalendar col-xs-12">
                {(this.state.loader === true) ? <div className="localLoader">
                    <div className="localSpinner"></div>
                </div> : ''}
                <div className="selectMonthNavigationTitle">Kuukausi</div>
                {(this.props.activeFilterDoctor != null) ?
                    <div className="activeFilterDoctor activeFilterDoctorInCalendar">
                        <span>{this.props.activeFilterDoctor}<img onClick={this.disableFilterDoctor}
                                                                  alt="closeDoctorFilterIcon"
                                                                  src={closeDoctorFilterIcon}/></span></div> : ''}
                <DayPicker
                    locale='fi'
                    weekdaysShort={WEEKDAYS_SHORT['fi']}
                    months={MONTHS['fi']}
                    weekdaysLong={WEEKDAYS_LONG['fi']}
                    firstDayOfWeek={FIRST_DAY_OF_WEEK['fi']}
                    labels={LABELS['fi']}
                    className={(this.props.activeFilterDoctor != null) ? 'addMarginBottom' : ''}
                    showOutsideDays
                    fixedWeeks
                    selectedDays={this.state.freeDayList}
                    onDayClick={this.handleDayClick}
                />

                <NotificationContainer/>

            </div>
        );
    }
}

export default FilterCalendar;



// WEBPACK FOOTER //
// ./src/components/Step_3/FilterCalendar.jsx